import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { SystemError } from '@offerzen/pinata-shame'

import { hideSystemError, clearSystemError } from './reducers'
import { systemErrorVisible, systemErrorMessage } from './selectors'

const SystemErrorRedux = props => <SystemError {...props} />

const mapStateToProps = state => ({
  message: systemErrorMessage(state),
  visible: systemErrorVisible(state),
})

const mapDispatchToProps = {
  hide: hideSystemError,
  clear: clearSystemError,
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemErrorRedux)

SystemErrorRedux.propTypes = {
  offsetTop: PropTypes.number,
  visible: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
  hide: PropTypes.func,
  clear: PropTypes.func,
  hideTimeout: PropTypes.number,
}
